import { lazy, Suspense, useEffect, useRef, useState } from 'react';

const HomePageDeferredContent = lazy(() => import('./HomePageDeferredContent'));

export default function HomePageDeferredBoundary({ content }) {
  const [shouldLoad, setShouldLoad] = useState(() => (
    typeof window !== 'undefined'
    && (window.location.hash === '#newsletter-signup' || typeof IntersectionObserver === 'undefined')
  ));
  const sentinelRef = useRef(null);

  useEffect(() => {
    if (shouldLoad) return undefined;
    const element = sentinelRef.current;
    if (!element) return undefined;

    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      setShouldLoad(true);
      observer.disconnect();
    }, { rootMargin: '200px 0px' });
    observer.observe(element);

    const loadForNewsletterAnchor = () => {
      if (window.location.hash === '#newsletter-signup') setShouldLoad(true);
    };
    window.addEventListener('hashchange', loadForNewsletterAnchor);
    return () => {
      observer.disconnect();
      window.removeEventListener('hashchange', loadForNewsletterAnchor);
    };
  }, [shouldLoad]);

  return (
    <div ref={sentinelRef} aria-busy={!shouldLoad}>
      {shouldLoad ? (
        <Suspense fallback={<div aria-hidden="true" className="min-h-[280px] animate-pulse bg-white" />}>
          <HomePageDeferredContent content={content} />
        </Suspense>
      ) : <div aria-hidden="true" className="min-h-[280px]" />}
    </div>
  );
}
